import { c as _c } from "react/compiler-runtime";
import { Button, Drawer } from '@systemeio/components';
import { XCloseIcon } from '@systemeio/icons';
import EmptyFunnelStepList from 'modules/funnels/funnel/components/empty-funnel-step-list';
import { FunnelSettingsTabbar } from 'modules/funnels/funnel/components/funnel-settings-tabbar';
import { FunnelStepPageActions } from 'modules/funnels/funnel/components/funnel-step-page-actions/funnel-step-page-actions';
import { FunnelStepsCompactNavigation, getAdjacentFunnelStep } from 'modules/funnels/funnel/components/funnel-steps-compact-navigation';
import FunnelStepsList from 'modules/funnels/funnel/components/funnel-steps-list';
import FunnelStepsListSkeleton from 'modules/funnels/funnel/components/funnel-steps-list-skeleton';
import { StepsTitle } from 'modules/funnels/funnel/components/steps-title';
import { TabContentLoader } from 'modules/funnels/funnel/components/tab-content-loader';
import type { FunnelStepInterface } from 'modules/funnels/funnel/types/funnel-step-interface';
import type { FunnelViewProps } from 'modules/funnels/funnel/types/funnel-view-props';
import { getFunnelStepSettingTabContent } from 'modules/funnels/funnel/utils/get-funnel-step-setting-tab-content';
import { isFunnelStepSplitTestVariant } from 'modules/funnels/funnel/utils/split-tests-utils';
import { useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useMediaQuery from 'shared/hooks/use-media-query';
import { CONTENT_HORIZONTAL_PADDING_CLASSNAME } from 'shared/layout/constants/layout-class-names';
import { twJoin } from 'tailwind-merge';
function FunnelTabletMobileView(t0) {
  const $ = _c(50);
  const {
    activeTab,
    funnelId,
    funnelSteps,
    isFunnelListEmpty,
    mutate,
    selectFunnelStep,
    selectFunnelStepTab,
    selectedFunnelStep,
    settingsTabs,
    tabsDisabled
  } = t0;
  const {
    t,
    tICU
  } = useLocoTranslation();
  const {
    isMobile,
    isTablet
  } = useMediaQuery();
  const [open, setOpen] = useState(false);
  const totalSteps = funnelSteps?.length ?? 0;
  let t1;
  if ($[0] !== funnelSteps || $[1] !== selectedFunnelStep?.id) {
    t1 = funnelSteps?.findIndex(funnelStep => funnelStep.id === selectedFunnelStep?.id) ?? -1;
    $[0] = funnelSteps;
    $[1] = selectedFunnelStep?.id;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const selectedStepIndex = t1;
  const currentStep = selectedStepIndex + 1;
  let t2;
  if ($[3] !== tICU || $[4] !== totalSteps) {
    t2 = tICU("dashboard.funnel.steps.title", {
      count: totalSteps
    });
    $[3] = tICU;
    $[4] = totalSteps;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const stepsLabel = t2;
  const selectedPage = selectedFunnelStep?.page;
  let t3;
  if ($[6] !== t) {
    t3 = funnelStep_0 => {
      if (funnelStep_0.goalFunnelStepOfAnySplitTest) {
        return {
          color: "blue" as const,
          label: t("dashboard.funnel.split_tests.goal_page_tooltip")
        };
      }
      if (!isFunnelStepSplitTestVariant(funnelStep_0)) {
        return;
      }
      return funnelStep_0.inRunningSplitTest ? {
        color: "active" as const,
        label: t("dashboard.funnel.split_tests.running_tooltip")
      } : {
        color: "inactive" as const,
        label: t("dashboard.funnel.split_tests.not_running")
      };
    };
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const getSplitTestStatus = t3;
  let t4;
  if ($[8] !== selectFunnelStep) {
    t4 = funnelStep_1 => {
      selectFunnelStep(funnelStep_1);
      setOpen(false);
    };
    $[8] = selectFunnelStep;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const handleSelectFunnelStep = t4;
  let t5;
  if ($[10] !== funnelSteps || $[11] !== selectFunnelStep || $[12] !== selectedStepIndex) {
    t5 = offset => {
      const funnelStep_2 = getAdjacentFunnelStep(funnelSteps, selectedStepIndex, offset);
      if (funnelStep_2) {
        selectFunnelStep(funnelStep_2);
      }
    };
    $[10] = funnelSteps;
    $[11] = selectFunnelStep;
    $[12] = selectedStepIndex;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const selectAdjacentStep = t5;
  const t6 = funnelSteps?.length;
  let t7;
  if ($[14] !== t6) {
    t7 = <StepsTitle count={t6} />;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== funnelId || $[17] !== funnelSteps || $[18] !== handleSelectFunnelStep || $[19] !== isFunnelListEmpty || $[20] !== mutate || $[21] !== selectedFunnelStep) {
    t8 = funnelSteps ? <FunnelStepsList funnelId={funnelId} funnelSteps={funnelSteps} mutate={mutate} selectedFunnelStep={selectedFunnelStep} selectFunnelStep={handleSelectFunnelStep} isFunnelListEmpty={isFunnelListEmpty} /> : <FunnelStepsListSkeleton />;
    $[16] = funnelId;
    $[17] = funnelSteps;
    $[18] = handleSelectFunnelStep;
    $[19] = isFunnelListEmpty;
    $[20] = mutate;
    $[21] = selectedFunnelStep;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== t7 || $[24] !== t8) {
    t9 = <>{t7}{t8}</>;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  const drawerContent = t9;
  const t10 = selectedPage && "pb-18";
  let t11;
  if ($[26] !== t10) {
    t11 = twJoin("flex min-w-0 flex-col gap-5", t10);
    $[26] = t10;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== activeTab || $[29] !== currentStep || $[30] !== drawerContent || $[31] !== funnelId || $[32] !== getSplitTestStatus || $[33] !== isFunnelListEmpty || $[34] !== isMobile || $[35] !== isTablet || $[36] !== open || $[37] !== selectAdjacentStep || $[38] !== selectFunnelStepTab || $[39] !== selectedFunnelStep || $[40] !== selectedPage || $[41] !== settingsTabs || $[42] !== stepsLabel || $[43] !== t || $[44] !== tabsDisabled || $[45] !== totalSteps) {
    t12 = isFunnelListEmpty ? <EmptyFunnelStepList /> : <><FunnelSettingsTabbar activeTab={activeTab} className="full-bleed" onSelectTab={selectFunnelStepTab} tabs={settingsTabs} tabsDisabled={tabsDisabled} />{!selectedFunnelStep && <TabContentLoader />}{selectedFunnelStep && <><FunnelStepsCompactNavigation title={selectedFunnelStep.name} currentStep={currentStep} nextLabel={t("global.next")} onNext={() => selectAdjacentStep(1)} onOpen={() => setOpen(true)} onPrevious={() => selectAdjacentStep(-1)} previousLabel={t("global.previous")} splitTestStatus={getSplitTestStatus(selectedFunnelStep)} stepsLabel={stepsLabel} totalSteps={totalSteps} />{getFunnelStepSettingTabContent(funnelId, selectedFunnelStep, activeTab)}{selectedPage && <div className={twJoin(CONTENT_HORIZONTAL_PADDING_CLASSNAME, "bg-bg-primary fixed inset-x-0 bottom-0 z-40 flex h-18 items-center justify-between gap-3 py-4", isTablet ? "shadow-3" : "border-border-100 border-t")}><FunnelStepPageActions funnelId={funnelId} funnelStep={selectedFunnelStep} pageId={selectedPage.id} /></div>}{isMobile && <Drawer.Root onOpenChange={setOpen} open={open}><Drawer.Popup><Drawer.Header className="flex-row items-center justify-between gap-2.5"><Drawer.Title className="capitalize">{stepsLabel}</Drawer.Title><Drawer.Close aria-label={t("global.close")} render={<Button size="icon-sm" variant="ghost-gray" />}><XCloseIcon /></Drawer.Close></Drawer.Header><Drawer.Content className="gap-0">{drawerContent}</Drawer.Content></Drawer.Popup></Drawer.Root>}{isTablet && <Drawer.Root modal={false} onOpenChange={setOpen} open={open} side="left"><Drawer.Popup className="bg-bg-primary w-89"><div className="flex items-center justify-between gap-2.5 px-6 py-4"><Drawer.Title className="text-text-primary text-xl font-semibold capitalize">{stepsLabel}</Drawer.Title><Drawer.Close aria-label={t("global.close")} render={<Button size="icon-sm" variant="ghost-gray" />}><XCloseIcon /></Drawer.Close></div><div className="min-h-0 flex-1 overflow-y-auto px-6 py-4">{drawerContent}</div></Drawer.Popup></Drawer.Root>}</>}</>;
    $[28] = activeTab;
    $[29] = currentStep;
    $[30] = drawerContent;
    $[31] = funnelId;
    $[32] = getSplitTestStatus;
    $[33] = isFunnelListEmpty;
    $[34] = isMobile;
    $[35] = isTablet;
    $[36] = open;
    $[37] = selectAdjacentStep;
    $[38] = selectFunnelStepTab;
    $[39] = selectedFunnelStep;
    $[40] = selectedPage;
    $[41] = settingsTabs;
    $[42] = stepsLabel;
    $[43] = t;
    $[44] = tabsDisabled;
    $[45] = totalSteps;
    $[46] = t12;
  } else {
    t12 = $[46];
  }
  let t13;
  if ($[47] !== t11 || $[48] !== t12) {
    t13 = <div className={t11}>{t12}</div>;
    $[47] = t11;
    $[48] = t12;
    $[49] = t13;
  } else {
    t13 = $[49];
  }
  return t13;
}
export { FunnelTabletMobileView };